import React, { useEffect, useState } from 'react';
import { FormControlLabel, Grid2 as Grid, Box } from '@mui/material';

import { StyledCheckBox } from '../../styled/checkbox.input';

// TODO: type this properly
export const CheckboxInput = ({
  field,
  design,
  onChange,
  submissionCount,
  error,
  isTwoColumn = false,
}: any) => {
  // since checkbox is controlled, need to manually reset the component when user restarts form
  const [checkedValues, setCheckedValues] = useState<string[]>([]);
  useEffect(() => {
    setCheckedValues([]);
  }, [submissionCount]);

  return (
    <Grid sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
      {field.options.map((event: any, index: any) => {
        const isChecked = checkedValues.includes(event.value);
        return (
          <>
            {isTwoColumn && (
              <Box key={index} sx={{ flex: '1 1 calc(50% - 5px)' }}>
                <FormControlLabel
                  key={index}
                  label={event.title}
                  sx={{
                    color: design.colors.question,
                    borderRadius: '8px',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    width: '100%',
                    marginRight: '0px',
                    marginLeft: '0px',
                    //padding: '1%',
                    // https://stackoverflow.com/questions/19248985/how-to-prevent-shifting-when-changing-border-width
                    transition: 'box-shadow 0.1s linear',
                    borderColor: [
                      isChecked ? 'transparent' : design.colors.question,
                      error ? '#e42525' : 'transparent',
                    ],
                    boxShadow: [
                      isChecked
                        ? `0 0 0 5px ${design.colors.button}`
                        : `0 0 0 1px ${design.colors.question}`,
                      error ? 'none' : 'transparent',
                    ],
                  }}
                  control={
                    <StyledCheckBox
                      name={field.id}
                      id={field.id}
                      value={event.value}
                      checked={isChecked}
                      error={error}
                      onChange={(e: any) => {
                        if (e.target.checked) {
                          setCheckedValues([...checkedValues, event.value]);
                        } else {
                          setCheckedValues(
                            checkedValues.filter((v) => v !== event.value)
                          );
                        }
                        onChange(e);
                      }}
                      design={design}
                    />
                  }
                />
              </Box>
            )}

            {!isTwoColumn && (
              <Box
                key={index}
                sx={{
                  width: '100%',
                  display: 'inline-block',
                  verticalAlign: 'top',
                  marginLeft: '10px',
                }}
              >
                <FormControlLabel
                  key={index}
                  label={event.title}
                  sx={{
                    color: design.colors.question,
                    borderRadius: '8px',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    marginBottom: '16px',
                    width: '100%',
                    marginRight: '0px',
                    //padding: '1%',
                    // https://stackoverflow.com/questions/19248985/how-to-prevent-shifting-when-changing-border-width
                    transition: 'box-shadow 0.1s linear',
                    borderColor: [
                      isChecked ? 'transparent' : design.colors.question,
                      error ? '#e42525' : 'transparent',
                    ],
                    boxShadow: [
                      isChecked
                        ? `0 0 0 5px ${design.colors.button}`
                        : `0 0 0 1px ${design.colors.question}`,
                      error ? 'none' : 'transparent',
                    ],
                  }}
                  control={
                    <StyledCheckBox
                      name={field.id}
                      id={field.id}
                      value={event.value}
                      checked={isChecked}
                      error={error}
                      onChange={(e: any) => {
                        if (e.target.checked) {
                          setCheckedValues([...checkedValues, event.value]);
                        } else {
                          setCheckedValues(
                            checkedValues.filter((v) => v !== event.value)
                          );
                        }
                        onChange(e);
                      }}
                      design={design}
                    />
                  }
                />
              </Box>
            )}
          </>
        );
      })}
    </Grid>
  );
};
